export default {"src":"/_next/static/media/catalog-sort-curtainClose.69ec0ddf.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};